import styled from 'styled-components';

type TextButtonProps = {
  fontColor?: string;
};

const TextButton = styled.button<TextButtonProps>`
  text-decoration: underline;
  background: none;
  border: none;
  color: ${({ fontColor }) => fontColor || 'var(--color-primary)'};
  ${({ theme }) => theme.fontSize('16px')};
  font-family: ${({ theme }) => theme.fonts.family};
  font-weight: 500;
  padding-inline-start: 4px;
`;

export default TextButton;
